import { getCalendarPlanWithThemes } from '@yandex-int/k-common/client/api/defs/get-calendar-plan-with-themes';
import { SUBJECTS_SLUGS_TYPE } from 'platform-components';
import { useQuery } from 'react-query';
import { getCoursesTemplates } from '@yandex-int/k-common/client/api/defs/get-courses-templates';
async function getCalendarPlanWithThemesRequest(subject: SUBJECTS_SLUGS_TYPE, grade: number) {
    try {
        return await getCalendarPlanWithThemes({ subject, grade });
    } catch (e) {
        if (e.status === 404) {
            return null;
        }

        throw e;
    }
}

export function useCalendarPlanQuery(subject: SUBJECTS_SLUGS_TYPE, grade: number | null, enabled = true) {
    return useQuery(['getCalendarPlanQuery', subject, grade], () => getCalendarPlanWithThemesRequest(subject, grade!), {
        enabled: Boolean(grade && subject && enabled),
        staleTime: Infinity,
    });
}

export function useCoursesTemplates(classId: number | null) {
    return useQuery(['getCoursesTemplates', classId], async () => await getCoursesTemplates({ classId }), {
        enabled: Boolean(classId),
    });
}
